(function() {

    //Preload loader image on document load
    //This allows inmediate visualization if loader is showed by any event
    window.addEventListener("load", () => {
        document.querySelectorAll('.shared-loading-animation-wrapper').forEach(block => {
            const loaderImageSrc = block.querySelector('.loading-animation-icon').src;
            const img = new Image();
            img.src = loaderImageSrc;
        });
    });

    document.addEventListener(window.AseguraGoConstants.ASEGURAGO_SHOW_LOADER_EVENT, (event) => {
        document.querySelector('.shared-loading-animation-wrapper').classList.remove('hidden');
    });

    document.addEventListener(window.AseguraGoConstants.ASEGURAGO_HIDE_LOADER_EVENT, (event) => {
        //We assuer all loaders are hidden if not same order recovering from DOM
        document.querySelectorAll('.shared-loading-animation-wrapper').forEach(block => {
            block.classList.add('hidden');
        });
    });

})();